import { useSyncExternalStore } from 'react'

/**
 * Whether a CSS media query matches right now, updating as the window
 * resizes. Lets a component skip mounting what a breakpoint would only hide.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mediaList = window.matchMedia(query)
      mediaList.addEventListener('change', onChange)
      return () => mediaList.removeEventListener('change', onChange)
    },
    () => window.matchMedia(query).matches,
    () => false,
  )
}
